import { BUYER_REGISTRATION, BUYER_REGISTRATION_FORM } from '../Action/type';

const initialState = {
    isResistered: false,
    user: {}
}

export default function(state = initialState, action) {
    switch (action.type) {
        case BUYER_REGISTRATION:
            return {
                ...state,
                user: action.payload
            };
        case BUYER_REGISTRATION_FORM:
            return {
                ...state,
                user: action.payload
            }

        default:
            return state;
    }

}